//! Upsell swiper initialization function
function initializeUpsellSwiper() {
  // Find the unique section wrapper
  const section = document.querySelector('#cart-upsell');
  if (!section) return;

  // Find elements *within* this section
  const upsellSwiperEl = section.querySelector('.upsell-swiper');
  
  const paginationEl = section.querySelector('.swiper-pagination');

  // Initialize Upsell Swiper (Main Driver)
  const upsellSwiper = new Swiper(upsellSwiperEl, {
    loop: true,
    grabCursor: true,
    pagination: {
      el: paginationEl,
      type: 'bullets',
      dynamicBullets: true,
      dynamicMainBullets: 2,  // number of bullets to show
      clickable: true,
    },
  });
}

// function initializeUpsellSwiper() {
//   const swiperElements = document.querySelectorAll(".upsellSwiper");

//   swiperElements.forEach((el) => {
//     if (!el.swiper) {
//       new Swiper(el, {
//         slidesPerView: 1,
//         loop: true,
//         spaceBetween: 10,

//         navigation: {
//           nextEl: el.querySelector("#upsell .swiper-button-next"),
//           prevEl: el.querySelector("#upsell .swiper-button-prev"),
//         },
//       });
//     }
//   });
// }

//! CUSTOM CART FOR CART DRAWER AND CART SECTION
// class CustomCart extends HTMLElement {
//   constructor() {
//     super();

//     this.sectionId = this.dataset.sectionId;
//   }

//   connectedCallback() {
//     // Once the cart:rerender event is set up, we can call it from everywhere we want in the theme
//     // just don't forget to append the correct data to the event so we can rerender the cart

//     this.cartType = this.dataset.cartType || "drawer";

//     document.addEventListener("cart:rerender", this.cartRerender.bind(this));
//   }

//   cartRerender(event) {
//     if (!event.detail.sections) {
//       console.error("No sections data available for rerender");
//       return;
//     }

//     //! Cart
//     const cartPlaceholder = document.createElement("div");
//     let cartOriginalSection;
//     let contentSelector;

//     // Determine which section data to use based on cart type
//     if (this.cartType === "page") {
//       cartOriginalSection =
//         event.detail.sections[this.sectionId] || event.detail.sections["cart"];
//       contentSelector = ".cart-section";
//     } else {
//       cartOriginalSection = event.detail.sections["cart-drawer"];
//       contentSelector = ".cart-drawer";
//     }

//     if (!cartOriginalSection) {
//       console.error(`No section data found for cart type: ${this.cartType}`);
//       return;
//     }

//     cartPlaceholder.innerHTML = cartOriginalSection;

//     //! This is only necessary for the cart drawer, as the cart section is rendered within the custom-cart element.
//     //! Find the cart drawer content - it might have been relocated to document.body by our sheet-menu custom web component, which moves the sheet-content to the body for improved overlay handling and positioning.
//     let cartContent = this.querySelector(contentSelector);

//     //! This is only necessary for the cart drawer, as the cart section is rendered within the custom-cart element.
//     //! If not found within the custom-cart element, search the entire document.
//     //! This accounts for our sheet-menu custom web component moving the sheet-content to document.body for better modal behavior.
//     if (!cartContent) {
//       cartContent = document.querySelector(contentSelector);
//     }

//     //! Our <sheet-menu> (the cart drawer) isn’t added to the DOM until it’s opened—this ensures it behaves like a modal. That means when you click the product’s Add to Cart button, the drawer element doesn’t yet exist in the DOM, so its content cannot be found or re-rendered.
//     //! The code nevertheless retrieves and updates the <sheet-menu>’s content by accessing the sheetContent property of the sheet-menu custom element, which maintains an internal reference to the content element.
//     //! This allows updates even before it's attached to the DOM, working because the custom element holds this reference independently of the DOM structure.
//     if (!cartContent && this.cartType === "drawer") {
//       const sheetMenu = this.querySelector("sheet-menu");
//       if (sheetMenu && sheetMenu.sheetContent) {
//         cartContent = sheetMenu.sheetContent;
//       }
//     }

//     if (cartContent) {
//       // Update the content
//       const newContent = cartPlaceholder.querySelector(contentSelector);
//       if (newContent) {
//         cartContent.innerHTML = newContent.innerHTML;
//       } else {
//         console.error(
//           `Could not find ${contentSelector} element in cartPlaceholder`
//         );
//         return;
//       }

//       //! Re-add the close button dynamically if it's missing after rerendering.
//       //! This is necessary because rerendering the cart content replaces the DOM elements, preventing the sheet-menu web component from automatically adding the close button during its initial setup.
//       //! We manually call the method to ensure the close button is added post-rerender for proper sheet closing functionality.
//       if (this.cartType === "drawer") {
//         const sheetContent = cartContent.closest("sheet-content");
//         if (
//           sheetContent &&
//           !sheetContent.querySelector(".sheet-close-trigger")
//         ) {
//           // Find the sheet-menu that contains this content
//           const sheetMenu = this.querySelector("sheet-menu");
//           if (sheetMenu && sheetMenu._addCloseButton) {
//             sheetMenu._addCloseButton();
//           } else {
//             console.error("Could not find sheet-menu element in custom-cart");
//             return;
//           }
//         }
//       }
//     } else {
//       console.error(
//         `Could not find ${contentSelector} element even via sheet-menu reference`
//       );
//     }

//     // For drawer: Open the sheet menu if it exists
//     if (this.cartType === "drawer") {
//       const sheetMenu =
//         this.querySelector("sheet-menu") ||
//         document.querySelector("sheet-menu");
//       if (sheetMenu) {
//         sheetMenu.open();
//       }
//     }

//     //! Re-initialize cart item tooltips after cart rerender
//     setTimeout(initializeCartItemTooltips, 100);

//     //! Re-initialize upsell item tooltips after cart rerender
//     setTimeout(initializeUpsellItemTooltips, 100);

//     //! Re-initialize upsell swiper after cart rerender
//     setTimeout(() => {
//       initializeUpsellSwiper();
//     }, 100);

//     //! Cart Icon
//     const cartIconPlaceholder = document.createElement("div");
//     const cartIconOriginalSection = event.detail.sections["cart-icon"];

//     cartIconPlaceholder.innerHTML = cartIconOriginalSection;

//     // Search for cart icon globally in the document
//     //! We perform a global search for the cart icon since it is not rendered within the custom-cart element on the cart section, ensuring updates across the entire page.
//     const cartIconContent = document.querySelector(".cart-icon");

//     if (cartIconContent) {
//       // Update the content
//       const newContent = cartIconPlaceholder.querySelector(".cart-icon");
//       if (newContent) {
//         cartIconContent.innerHTML = newContent.innerHTML;
//       } else {
//         console.error(
//           "Could not find .cart-icon element in cartIconPlaceholder"
//         );
//         return;
//       }
//     } else {
//       console.error("Could not find .cart-icon element");
//       return;
//     }
//   }
// }

class CustomCart extends HTMLElement {
  constructor() {
    super();

    this.sectionId = this.dataset.sectionId;
  }

  connectedCallback() {
    // Once the cart:rerender event is set up, we can call it from everywhere we want in the theme
    // just don't forget to append the correct data to the event so we can rerender the cart

    this.cartType = this.dataset.cartType || "drawer";

    document.addEventListener("cart:rerender", this.cartRerender.bind(this));
  }

  cartRerender(event) {
    if (!event.detail.sections) {
      console.error("No sections data available for rerender");
      return;
    }

    //! Cart
    const cartPlaceholder = document.createElement("div");
    let cartOriginalSection;
    let contentSelector;

    // Determine which section data to use based on cart type
    if (this.cartType === "page") {
      cartOriginalSection =
        event.detail.sections[this.sectionId] || event.detail.sections["cart"];
      contentSelector = ".cart-section";
    } else {
      cartOriginalSection = event.detail.sections["cart-drawer"];
      contentSelector = ".cart-drawer";
    }

    if (!cartOriginalSection) {
      console.error(`No section data found for cart type: ${this.cartType}`);
      return;
    }

    cartPlaceholder.innerHTML = cartOriginalSection;

    //! This is only necessary for the cart drawer, as the cart section is rendered within the custom-cart element.
    //! Find the cart drawer content - it might have been relocated to document.body by our sheet-menu custom web component, which moves the sheet-content to the body for improved overlay handling and positioning.
    let cartContent = this.querySelector(contentSelector);

    //! This is only necessary for the cart drawer, as the cart section is rendered within the custom-cart element.
    //! If not found within the custom-cart element, search the entire document.
    //! This accounts for our sheet-menu custom web component moving the sheet-content to document.body for better modal behavior.
    if (!cartContent) {
      cartContent = document.querySelector(contentSelector);
    }

    //! Our <sheet-menu> (the cart drawer) isn’t added to the DOM until it’s opened—this ensures it behaves like a modal. That means when you click the product’s Add to Cart button, the drawer element doesn’t yet exist in the DOM, so its content cannot be found or re-rendered.
    //! The code nevertheless retrieves and updates the <sheet-menu>’s content by accessing the sheetContent property of the sheet-menu custom element, which maintains an internal reference to the content element.
    //! This allows updates even before it's attached to the DOM, working because the custom element holds this reference independently of the DOM structure.
    if (!cartContent && this.cartType === "drawer") {
      const sheetMenu = this.querySelector("sheet-menu");
      if (sheetMenu && sheetMenu.sheetContent) {
        cartContent = sheetMenu.sheetContent;
      }
    }

    if (cartContent) {
      // Update the content
      const newContent = cartPlaceholder.querySelector(contentSelector);
      if (newContent) {
        cartContent.innerHTML = newContent.innerHTML;
      } else {
        console.error(
          `Could not find ${contentSelector} element in cartPlaceholder`
        );
        return;
      }

    } else {
      console.error(
        `Could not find ${contentSelector} element even via sheet-menu reference`
      );
    }

    // For drawer: Open the sheet menu if it exists
    if (this.cartType === "drawer") {
      const sheetMenu =
        this.querySelector("sheet-menu") ||
        document.querySelector("sheet-menu");
      if (sheetMenu) {
        sheetMenu.open();
      }
    }

    //! Clear all loading states after rerender
    setTimeout(() => {
      this.clearAllLoadingStates();
    }, 100);

    //! Re-initialize upsell swiper after cart rerender
    setTimeout(() => {
      initializeUpsellSwiper();
    }, 100);

    //! Cart Icon
    const cartIconPlaceholder = document.createElement("div");
    const cartIconOriginalSection = event.detail.sections["cart-icon"];

    cartIconPlaceholder.innerHTML = cartIconOriginalSection;

    //! Search for cart icon globally in the document
    //! We perform a global search for the cart icon since it is not rendered within the custom-cart element on the cart section, ensuring updates across the entire page.
    const cartIconContent = document.querySelector(".cart-icon");

    if (cartIconContent) {
      // Update the content
      const newContent = cartIconPlaceholder.querySelector(".cart-icon");
      if (newContent) {
        cartIconContent.innerHTML = newContent.innerHTML;
      } else {
        console.error(
          "Could not find .cart-icon element in cartIconPlaceholder"
        );
        return;
      }
    } else {
      console.error("Could not find .cart-icon element");
      return;
    }
  }

  clearAllLoadingStates() {
    //! Remove loading classes from all cart actions
    const cartActions = this.querySelectorAll("cart-actions");
    cartActions.forEach((action) => {
      if (action.setLoadingState) {
        action.setLoadingState(false);
      }
    });

    //! Remove loading classes from price elements
    const priceElements = document.querySelectorAll(".price-loading");
    priceElements.forEach((element) => {
      element.classList.remove("price-loading");
    });
  }
}

customElements.define("custom-cart", CustomCart);

class AtcButton extends HTMLElement {
  constructor() {
    super();

    this.submitForm = this.querySelector('form[action="/cart/add"]') || this.closest('form[action="/cart/add"]');
    this.submitButton = null;
    this.originalButtonText = "";
    this.isLoading = false;
  }

  connectedCallback() {
    if (this.submitForm) {
      this.submitButton = this.submitForm.querySelector(
        'button[type="submit"]'
      );
      if (this.submitButton) {
        this.originalButtonText = this.submitButton.textContent;
      }
      this.submitForm.addEventListener("submit", this.handleSubmit.bind(this));
    }
  }

  setLoadingState(loading) {
    if (!this.submitButton) return;

    this.isLoading = loading;

    if (loading) {
      this.submitButton.disabled = true;
      this.submitButton.textContent = "Adding...";
      this.submitButton.classList.add("loading");
    } else {
      this.submitButton.disabled = false;
      this.submitButton.textContent = this.originalButtonText;
      this.submitButton.classList.remove("loading");
    }
  }

  showError(message) {
    // Remove any existing error
    let errorElem = this.submitForm.querySelector(".atc-error-message");
    if (!errorElem) {
      errorElem = document.createElement("div");
      errorElem.className = "atc-error-message";
      errorElem.style.color = "red";
      errorElem.style.marginBottom = "1em";
      this.submitForm.prepend(errorElem);
    }
    errorElem.textContent = message;
  }

  clearError() {
    const errorElem = this.submitForm.querySelector(".atc-error-message");
    if (errorElem) errorElem.remove();
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.isLoading) return;
    this.clearError();
    this.setLoadingState(true);

    // Gather basic item data
    const variantInput = this.submitForm.querySelector('input[name="id"]');
    const qtyInput = this.submitForm.querySelector('input[name="quantity"]');
    const itemId = variantInput ? variantInput.value : null;
    const quantity = qtyInput ? parseInt(qtyInput.value) : 1;

    // Build item object
    const itemData = { id: itemId, quantity: quantity };

    // Collect all line-item properties from the form
    const properties = {};
    this.submitForm
      .querySelectorAll('input[name^="properties["]')
      .forEach((input) => {
        const match = input.name.match(/properties\[(.+)\]/);
        if (match) {
          const propKey = match[1];
          properties[propKey] = input.value;
        }
      });
    if (Object.keys(properties).length) {
      itemData.properties = properties;
    }

    // Prepare AJAX payload
    const formData = {
      items: [itemData],
      sections: "cart-drawer,cart-icon",
    };

    // Submit to Shopify Ajax API
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    })
      .then(async (response) => {
        const data = await response.json();
        if (!response.ok) {
          // Handle error response (e.g., max quantity reached)
          if (data && data.status === 422 && data.description) {
            this.showError(data.description);
          } else {
            this.showError("An unexpected error occurred. Please try again.");
          }
          this.setLoadingState(false);
          return;
        }
        // Success: trigger cart rerender (existing logic)
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:rerender", { detail: data, bubbles: true })
        );
        this.setLoadingState(false);
      })
      .catch((error) => {
        console.error("Error adding to cart:", error);
        this.showError("An unexpected error occurred. Please try again.");
        this.setLoadingState(false);
      });
  }
}

customElements.define("atc-button", AtcButton);

// class AtcButton extends HTMLElement {
//   constructor() {
//     super();

//     this.submitForm = document.querySelector('form[action="/cart/add"]');
//     this.submitButton = null;
//     this.originalButtonText = "";
//     this.isLoading = false;
//   }

//   connectedCallback() {
//     if (this.submitForm) {
//       this.submitButton = this.submitForm.querySelector(
//         'button[type="submit"]'
//       );
//       if (this.submitButton) {
//         this.originalButtonText = this.submitButton.textContent;
//       }
//       this.submitForm.addEventListener("submit", this.handleSubmit.bind(this));
//     }
//   }

//   setLoadingState(loading) {
//     if (!this.submitButton) return;

//     this.isLoading = loading;

//     if (loading) {
//       this.submitButton.disabled = true;
//       this.submitButton.textContent = "Adding...";
//       this.submitButton.classList.add("loading");
//     } else {
//       this.submitButton.disabled = false;
//       this.submitButton.textContent = this.originalButtonText;
//       this.submitButton.classList.remove("loading");
//     }
//   }

//   handleSubmit(event) {
//     event.preventDefault();
//     if (this.isLoading) return;
//     this.setLoadingState(true);

//     // Gather basic item data
//     const variantInput = this.submitForm.querySelector('input[name="id"]');
//     const qtyInput = this.submitForm.querySelector('input[name="quantity"]');
//     const itemId = variantInput ? variantInput.value : null;
//     const quantity = qtyInput ? parseInt(qtyInput.value) : 1;

//     // Build item object
//     const itemData = { id: itemId, quantity: quantity };

//     // **NEW:** Collect all line-item properties from the form
//     const properties = {};
//     this.submitForm
//       .querySelectorAll('input[name^="properties["]')
//       .forEach((input) => {
//         const match = input.name.match(/properties\[(.+)\]/);
//         if (match) {
//           const propKey = match[1];
//           // You may want to skip empty or underscore-prefixed keys as needed
//           properties[propKey] = input.value;
//         }
//       });
//     // If any properties were found, attach them
//     if (Object.keys(properties).length) {
//       itemData.properties = properties;
//     }

//     // Prepare AJAX payload
//     const formData = {
//       items: [itemData],
//       sections: "cart-drawer,cart-icon",
//     };

//     // Submit to Shopify Ajax API
//     fetch(window.Shopify.routes.root + "cart/add.js", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(formData),
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         // trigger cart rerender (existing logic)
//         document.documentElement.dispatchEvent(
//           new CustomEvent("cart:rerender", { detail: data, bubbles: true })
//         );
//         this.setLoadingState(false);
//       })
//       .catch((error) => {
//         console.error("Error adding to cart:", error);
//         this.setLoadingState(false);
//       });
//   }
// }

// customElements.define('atc-button', AtcButton);

// class AtcButton extends HTMLElement {
//   constructor() {
//     super();

//     this.container = this.querySelector("div[data-variant-id]");
//     this.button = this.querySelector("button");
//   }

//   connectedCallback() {
//     if (this.button && this.container) {
//       this.button.addEventListener("click", this.handleClick.bind(this));
//     }
//   }

//   handleClick(event) {
//     event.preventDefault();
//     event.stopPropagation();

//     // Disable button to prevent multiple clicks
//     this.button.disabled = true;
//     const originalText = this.button.textContent;
//     this.button.textContent = "Adding...";

//     const variantId = this.container.dataset.variantId;
//     const quantity = this.container.dataset.quantity || "1";

//     let formData = {
//       items: [
//         {
//           id: variantId,
//           quantity: parseInt(quantity),
//         },
//       ],
//       sections: "cart-drawer,cart-icon",
//     };

//     fetch(window.Shopify.routes.root + "cart/add.js", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(formData),
//     })
//       .then((response) => {
//         return response.json();
//       })
//       .then((data) => {
//         document.documentElement.dispatchEvent(
//           new CustomEvent("cart:rerender", {
//             detail: data,
//             bubbles: true,
//           })
//         );
//       })
//       .catch((error) => {
//         console.error("Error:", error);
//       })
//       .finally(() => {
//         // Re-enable button
//         this.button.disabled = false;
//         this.button.textContent = originalText;
//       });
//   }
// }

// customElements.define("atc-button", AtcButton);

// class CartActions extends HTMLElement {
//   constructor() {
//     super();

//     this.increaseQuantity = this.querySelector("[data-increase-quantity]");
//     this.decreaseQuantity = this.querySelector("[data-decrease-quantity]");
//     this.removeItem = this.querySelector("[data-cart-item-remove]");

//     this.handleQuantityChange = this.handleQuantityChange.bind(this);
//   }

//   connectedCallback() {
//     if (this.increaseQuantity)
//       this.increaseQuantity.addEventListener(
//         "click",
//         this.handleQuantityChange
//       );
//     if (this.decreaseQuantity)
//       this.decreaseQuantity.addEventListener(
//         "click",
//         this.handleQuantityChange
//       );
//     if (this.removeItem)
//       this.removeItem.addEventListener("click", this.handleQuantityChange);
//   }

//   disconnectedCallback() {
//     if (this.increaseQuantity)
//       this.increaseQuantity.removeEventListener(
//         "click",
//         this.handleQuantityChange
//       );
//     if (this.decreaseQuantity)
//       this.decreaseQuantity.removeEventListener(
//         "click",
//         this.handleQuantityChange
//       );
//     if (this.removeItem)
//       this.removeItem.removeEventListener("click", this.handleQuantityChange);
//   }

//   handleQuantityChange(event) {
//     const line = this.dataset.line;
//     const quantity = event.currentTarget.dataset.quantity;

//     if (!line || quantity == null) {
//       console.error("Invalid line or quantity");
//       return;
//     }

//     // Get the cart type from the parent custom-cart element
//     const customCart = this.closest("custom-cart");
//     const cartType = customCart
//       ? customCart.dataset.cartType || "drawer"
//       : "drawer";

//     // Determine which sections to request
//     let sections;
//     if (cartType === "page") {
//       sections = customCart
//         ? `${customCart.dataset.sectionId},cart-icon`
//         : "cart,cart-icon";
//     } else {
//       sections = "cart-drawer,cart-icon";
//     }

//     const formData = {
//       line: line,
//       quantity: quantity,
//       sections: sections,
//     };

//     fetch(window.Shopify.routes.root + "cart/change.js", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(formData),
//     })
//       .then((response) => {
//         if (!response.ok) {
//           return response.json().then((err) => {
//             throw err;
//           });
//         }
//         return response.json();
//       })
//       .then((data) => {
//         document.documentElement.dispatchEvent(
//           new CustomEvent("cart:rerender", {
//             detail: data,
//             bubbles: true,
//           })
//         );
//       })
//       .catch((error) => {
//         console.error("Error updating cart:", error);
//         // Optionally, show error message to user
//       });
//   }
// }

class CartActions extends HTMLElement {
  constructor() {
    super();

    this.increaseQuantity = this.querySelector("[data-increase-quantity]");
    this.decreaseQuantity = this.querySelector("[data-decrease-quantity]");
    this.removeItem = this.querySelector("[data-cart-item-remove]");
    this.quantityInput = this.querySelector(".quantity-input");

    this.handleQuantityChange = this.handleQuantityChange.bind(this);
    this.isLoading = false;
  }

  connectedCallback() {
    if (this.increaseQuantity)
      this.increaseQuantity.addEventListener(
        "click",
        this.handleQuantityChange
      );
    if (this.decreaseQuantity)
      this.decreaseQuantity.addEventListener(
        "click",
        this.handleQuantityChange
      );
    if (this.removeItem)
      this.removeItem.addEventListener("click", this.handleQuantityChange);
  }

  disconnectedCallback() {
    if (this.increaseQuantity)
      this.increaseQuantity.removeEventListener(
        "click",
        this.handleQuantityChange
      );
    if (this.decreaseQuantity)
      this.decreaseQuantity.removeEventListener(
        "click",
        this.handleQuantityChange
      );
    if (this.removeItem)
      this.removeItem.removeEventListener("click", this.handleQuantityChange);
  }

  setLoadingState(loading, isRemoveAction = false) {
    this.isLoading = loading;

    //! Disable quantity buttons and input
    if (this.increaseQuantity) this.increaseQuantity.disabled = loading;
    if (this.decreaseQuantity) this.decreaseQuantity.disabled = loading;
    if (this.quantityInput) this.quantityInput.disabled = loading;

    //! Add loading class to container
    if (loading) {
      this.classList.add("loading");
    } else {
      this.classList.remove("loading");
    }

    //! For remove actions, only add shimmer to cart summary
    //! For quantity changes, add shimmer to both item price and cart summary
    if (!isRemoveAction) {
      //! Add shimmer to price elements in this cart item for quantity changes
      const cartItem = this.closest(".cart-item");
      if (cartItem) {
        const priceDetails = cartItem.querySelector(".cart-item-price-details");
        if (priceDetails) {
          if (loading) {
            priceDetails.classList.add("price-loading");
          } else {
            priceDetails.classList.remove("price-loading");
          }
        }
      }
    }

    //! Always add shimmer to cart summary totals for any action
    const cartSummaryTotals = document.querySelectorAll(".cart-summary-total");
    cartSummaryTotals.forEach((total) => {
      if (loading) {
        total.classList.add("price-loading");
      } else {
        total.classList.remove("price-loading");
      }
    });
  }

  handleQuantityChange(event) {
    //! Prevent multiple submissions
    if (this.isLoading) return;

    const line = this.dataset.line;
    const quantity = event.currentTarget.dataset.quantity;

    if (!line || quantity == null) {
      console.error("Invalid line or quantity");
      return;
    }

    //! Determine if this is a remove action (quantity = 0)
    const isRemoveAction = parseInt(quantity) === 0;

    //! Set loading state with remove action flag
    this.setLoadingState(true, isRemoveAction);

    //! Get the cart type from the parent custom-cart element
    const customCart = this.closest("custom-cart");
    const cartType = customCart
      ? customCart.dataset.cartType || "drawer"
      : "drawer";

    //! Determine which sections to request
    let sections;
    if (cartType === "page") {
      sections = customCart
        ? `${customCart.dataset.sectionId},cart-icon`
        : "cart,cart-icon";
    } else {
      sections = "cart-drawer,cart-icon";
    }

    const formData = {
      line: line,
      quantity: quantity,
      sections: sections,
    };

    fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((err) => {
            throw err;
          });
        }
        return response.json();
      })
      .then((data) => {
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:rerender", {
            detail: data,
            bubbles: true,
          })
        );
      })
      .catch((error) => {
        console.error("Error updating cart:", error);
        //! Remove loading state on error
        this.setLoadingState(false, isRemoveAction);
      });
  }
}

customElements.define("cart-actions", CartActions);

//! Wait for the upsell swiper to be initialized before initializing the swiper
function waitForUpsellSwiper(callback, maxWait = 10000) {
  const startTime = Date.now();

  function check() {
    const swiper = document.querySelector(".upsellSwiper");
    if (swiper) {
      callback();
    } else if (Date.now() - startTime < maxWait) {
      requestAnimationFrame(check);
    } else {
      console.warn("upsellSwiper not found after waiting.");
    }
  }

  check();
}

document.addEventListener("DOMContentLoaded", () => {
  waitForUpsellSwiper(() => {
    console.log("upsellSwiper found, initializing Swiper");
    initializeUpsellSwiper();
  });
});
